function isIsoDate(value: unknown) {
  if (typeof value !== 'string') {
    return false;
  }
  return /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z/.test(value);
}

export default isIsoDate;
